import api from "./api";

const qs = (p = {}) =>
  new URLSearchParams(Object.entries(p).filter(([, v]) => v !== "" && v != null && v !== undefined)).toString();

const svc = {
  buscarConfig:    (idCondominio)    => api("GET",  `/whatsapp/config?idCondominio=${idCondominio}`),
  salvarConfig:    (data)            => api("PUT",  `/whatsapp/config`, data),
  regenerarSecret: (idCondominio)    => api("POST", `/whatsapp/config/regenerar-secret`, { idCondominio }),
  conectar:        (idCondominio)    => api("POST", `/whatsapp/conectar`, { idCondominio }),
  status:          (idCondominio)    => api("GET",  `/whatsapp/status?idCondominio=${idCondominio}`),
  desconectar:     (idCondominio)    => api("POST", `/whatsapp/desconectar`, { idCondominio }),
  testar:          (data)            => api("POST", `/whatsapp/testar`, data),
  listarLog:       (params = {})     => api("GET",  `/whatsapp/log?${qs(params)}`),
  reenviarLog:     (id)              => api("POST", `/whatsapp/log/${id}/reenviar`, {}),
};
export default svc;
